import { removeInvalidOptions } from '../../field-viewer/shared-normalizers';
export const dextCheckboxGroupViewer = {
    normalizeLoadedValue: removeInvalidOptions
};

//# sourceMappingURL=definition-viewer.js.map